<template>
  <div class="teacherTeam">
    <headers class="herderNav" ref="header" :isChange="true" />
    <div class="teacherTeamCon">
      <h1>师资团队</h1>
      <div
        class="teacherTeamCard"
        v-for="(ele, index) in teacherTeam"
        :key="index"
      >
        <div class="teacherGmat">
          <p class="teacherName">{{ ele.nick }}</p>
          <div class="thevidoo" v-show="isShow">
            <video :src="ele.video" preload="auto" controls="controls"></video>
          </div>
          <!-- <p class="teacherName">{{ ele.nick }}</p>
          <div class="thevidoo" v-show="isShow">
            <video :src="base+video" preload="auto" controls="controls"></video>
          </div> -->
          <div class="teacherStartIcon" @click="openvideo()">
            <img
              @click="getIndex(ele)"
              src="../../assets/teacherTeam/startIcon.png"
            />
            <span>老师详情</span>
          </div>
        </div>
        <div class="teacherPhoto">
          <img :src="base + ele.teacher_avatar" />
        </div>
        <div class="teacherBrief">
          <p>INTRODUCTION</p>
          <div class="teacherAccount">{{ ele.profile }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/activeTest.js";
import home from "@/api/home.js";
import baseUrl from "@/api/common.js";
import headers from "../../components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      isShow: false,
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      navCodes: require("@/assets/login/whiteCode.png"),
      video: null,
      teacherTeam: [
        {
          id: "1",
          nick: "姜梦奇",
          subject: "GMAT数学&逻辑名师",
          teacher_avatar: "/uploads/teach/jmq.png",
          profile:
            "GMAT数学&逻辑名师，姜姜讲GMAT公众号主编，毕业于国际关系学院，英语专八，GMAT760。 8年GMAT授课经验，曾任新东方GMAT高端班型负责人、线上课负责人，曾为考满分一线顶流名师。深谙出题套路和陷阱形式，拥有完善的GMAT题库，擅长机经考古还原，拒绝马后炮式授课，致力于帮助学员构建全面的知识点体系、快速出分。累计教授学员过万，辅导出数百名GMAT700+和750+的学生。",
          video: "https://cdn.scoreupup.com/static/video/jmq.mp4",
        },
        {
          id: "2",
          nick: "侯乃武",
          subject: "GMAT阅读名师",
          teacher_avatar: "uploads/teach/hnw.png",
          profile:
            "TESOL认证教师，曾任太傻留学、考满分语法&逻辑讲师，10年一线专注GMAT辅导，著有《GMAT逻辑指导大全》、《GMAT语法POE宝典》，发表众多学术文章帮助学生解决困惑。熟练掌握市面所有题目，多次参加考试取得优异成绩（V维持40以上）。多年以实践和方法为导向总结出自己一套独特的教学理念和教学体系，以结果为导向打造高出分率，善于根据学生的个体差异和问题本质来解决各种出分难题。",
          video: "https://cdn.scoreupup.com/static/video/hnw.mp4",
        },
        {
          id: "3",
          nick: "胡勇",
          subject: "GMAT语法名师",
          teacher_avatar: "uploads/teach/hy.png",
          profile:
            "GMAT语法名师，毕业于北京外国语大学。 前新东方大班主力师资，前考满分初创名师团队之一。个人制作的OG/PREP/GWD所有官方语法真题的语音讲解，曾在喜马拉雅平台创下百万播放量。坚持以句意为核心，融合结构分析和语法点讲解，帮助大批学员攻克句子改错难关。9年教学经验，累计服务上万名GMAT考生。",
          video: "https://cdn.scoreupup.com/static/video/hy.mp4",
        },
        {
          id: "4",
          nick: "高宇琪",
          subject: "GMAT阅读名师",
          teacher_avatar: "uploads/teach/gyq.png",
          profile:
            "GMAT阅读名师，中国人民大学精算专业，前新东方GMAT&GRE项目教师培训组组长，8年教学经验，GMAT 760分，GRE 337分。著有《GMAT/GRE 长难句图解与精练》《解密阅读逻辑线——双线阅读法》。 曾赴哈佛和宾大进行交流学习，持有剑桥英语教学能力证书（TKT）。 教授的双线阅读法，直指GMAT考试要求的本质能力，踩准考点，帮助学生高效提分。累计教授上万名学生，带出大量GMAT 700+ 和 GRE330+ 的高分考生，包括多名GMAT 780和GRE满分（340）考生。",
          video: "https://cdn.scoreupup.com/static/video/gyq.mp4",
        },
        {
          id: "5",
          nick: "王凯",
          subject: "GMAT逻辑名师",
          teacher_avatar: "uploads/teach/wk.png",
          profile:
            "GMAT阅读名师，英语专业八级，GMAT770（Q51V44）。 在考满分、新东方在线有多年教学经验，主要教授阅读科目。为新东方在线《GMAT年度报告》(2019, 2020年度) 综合章、阅读章作者，曾获新东方杰出青年教师称号，以“颜值在线”与“激情授课”出道，收获大量学员好评，辅导出数百名GMAT770+的学生。",
          video: "https://cdn.scoreupup.com/static/video/wk.mp4",
        },
        {
          id: "6",
          nick: "金晶岚",
          subject: "GMAT语法&逻辑名师",
          teacher_avatar: "uploads/teach/jjl.png",
          profile:
            "GMAT数学满分，GRE数学满分，前考满分G类考试数学名师。擅长体系化知识点讲解，善于帮助学生高效出分，善于发现学生问题并解决问题。教授学生数千人，广受好评，曾帮助多位非中国考生（数学底子差），获得理想的GMAT成绩。",
          video: "https://cdn.scoreupup.com/static/video/jjl.mp4",
        },
      ],
      base: baseUrl,
    };
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
    // this.getTeacherList();
  },
  methods: {
    getIndex(ele) {
      this.video = ele.video;
    },
    openvideo() {
      if (this.video) {
        this.isShow = !this.isShow;
      }
    },
    // getTeacherList() {
    //   let params = {
    //     type: "home",
    //   };
    //   let query = this.$qs.stringify(params);
    //   home
    //     .getTeacher(query)
    //     .then((res) => {
    //       this.teacherTeam = res.data.data
    //     })
    //     .catch((err) => {
    //       this.$message.error("错误");
    //     });
    // },
  },
};
</script>
<style scoped>
@import url("../../assets/css/teacherteams.css");
</style>



// WEBPACK FOOTER //
// src/view/teacherTeam/teacherteams.vue